import React, { Component } from 'react';
import { Table, Row, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import imgSave from "../../../saveImg";
import Auth from "../../../Auth";
import TableText from "../../../TableText";
import { getJson, Num, calculation } from '@/method';
import { columns1, columns2, columns3, data1, data2, data3, defaultData } from "../data";
import request from '@/method/request';
import Title from "../Title";

const { MonthPicker } = DatePicker;

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: {},
            dataReview: [],
            dataPackage: [],
            dataRecommend: [],
            note: { note: "" },
            loading: true,
            loadingSave: false,
            print: false
        }
    }


    componentDidMount() {
        this.getData(this.state.date);
    }

    computeNum = (data) => {

        data.forEach((v, i) => {
            data[i].price = calculation(v.total_sales, v.qty);
            data[i].total_cost = (v.qty * v.cost).toFixed(2);
            data[i].percent = calculation(v.total_cost, v.total_sales, 4);
        });



    }

    onChange = (name, value, i) => {
        let data = this.state.dataReview;
        data[i][name] = value;
        this.setState({
            dataReview: data
        });
    }

    getData = async (date) => {
        const res = await request(`/es5_9?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}&type=1`);

        let data = JSON.parse(JSON.stringify(defaultData));
        let dataReview = JSON.parse(JSON.stringify(data1));
        let dataPackage = JSON.parse(JSON.stringify(data2));
        let dataRecommend = JSON.parse(JSON.stringify(data3));
        if (res.data.data) data = res.data.data;
        if (res.data.dataReview && res.data.dataReview.length) dataReview = res.data.dataReview.sort((a, b) => a.sort - b.sort);
        if (res.data.dataPackage && res.data.dataPackage.length) dataPackage = res.data.dataPackage.sort((a, b) => a.sort - b.sort);
        if (res.data.dataRecommend && res.data.dataRecommend.length) dataRecommend = res.data.dataRecommend.sort((a, b) => a.sort - b.sort);

        this.setState({ loading: false, data, dataReview, dataPackage, dataRecommend });
    }

    onSave = async () => {
        try {
            this.setState({ loadingSave: true });
            let { date, data, dataReview, dataPackage, dataRecommend } = this.state;
            if (!date) {
                message.error('请选择年份月份');
                let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
                return
            }
            let year = moment(date).format("YYYY");
            let month = moment(date).format("M");
            data = [{ ...data, year, month, t_type: 1 }];
            dataReview = dataReview.map(x => ({ ...x, year, month, t_type: 1 }));
            dataPackage = dataPackage.map(x => ({ ...x, year, month, t_type: 1 }));
            dataRecommend = dataRecommend.map(x => ({ ...x, year, month, t_type: 1 }));

            let dataFrom = new FormData();
            dataFrom.append('data', JSON.stringify(data));
            dataFrom.append('dataReview', JSON.stringify(dataReview));
            dataFrom.append('dataPackage', JSON.stringify(dataPackage));
            dataFrom.append('dataRecommend', JSON.stringify(dataRecommend));
            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {},
                body: dataFrom
            }

            const x = await request('/add5_9', headres);

            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        } catch (error) {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(error);
            message.error('保存失败' + JSON.stringify(error));
        }
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table5_6_1', 1.5, '5.91', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const { data, dataReview, dataPackage, dataRecommend, loading } = this.state;
        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title " id="table5_6_1"  >
                        <Row className="subtitle">西餐厅</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: {},
                                        dataReview: [],
                                        dataPackage: [],
                                        dataRecommend: [],
                                        loading: true,
                                        note: { note: "" }
                                    });
                                    this.getData(str)
                                }}
                            />
                        </Row>
                        {!loading && <Title data={data} t_type={1} name="西餐厅" onChange={(name, value) => {
                            let _data = { ...data };
                            _data[name] = value;
                            this.setState({ data: _data });
                        }} />}
                        <div className="list">
                            <span className="list-name">榜单上榜情况</span>
                            <Table
                                columns={columns1({ onChange: this.onChange, t_type: 1 })}
                                dataSource={dataReview}
                                size="middle"
                                bordered
                                pagination={false}
                                className="content"
                                rowKey={v => v.sort}
                            />
                        </div>
                        <div className="list">
                            <span className="list-name">套餐情况</span>
                            <Table
                                columns={columns2({
                                    onChange: (name, value, i) => {
                                        let data = this.state.dataPackage;
                                        data[i][name] = value;
                                        this.setState({
                                            dataPackage: data
                                        });
                                    }, t_type: 1
                                })}
                                dataSource={dataPackage}
                                size="middle"
                                bordered
                                pagination={false}
                                className="content"
                                rowKey={v => v.sort}
                            />
                        </div>
                        <div className="list">
                            <span className="list-name">推荐菜品 TOP3</span>
                            <Table
                                columns={columns3({
                                    onChange: (name, value, i) => {
                                        let data = this.state.dataRecommend;
                                        data[i][name] = value;
                                        this.setState({
                                            dataRecommend: data
                                        });
                                    }, t_type: 1
                                })}
                                dataSource={dataRecommend}
                                size="middle"
                                bordered
                                pagination={false}
                                className="content"
                                style={{ width: 600 }}
                                rowKey={v => v.sort}
                            />
                        </div>

                    </Row>
                    <Auth loading={this.state.loading} auth="edit_5_9">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-9/5-9-1/index.js